import type { LabelsMap } from '.';
import type { PersonalPageSubtype } from '../subtypes/types';

export const PERSONAL_PAGE_SUBTYPE_LABELS: LabelsMap<PersonalPageSubtype> = {
  openDonation: {
    singular: 'התרמה פתוחה',
    plural: 'התרמות פתוחות',
    gender: 'female',
    definiteArticle: 'all'
  },
  annualCampaign: {
    singular: 'קמפיין שנתי',
    plural: 'קמפיינים שנתיים',
    gender: 'male',
    definiteArticle: 'all'
  },
  partnershipCampaign: {
    singular: 'קמפיין שותפות',
    plural: 'קמפייני שותפות',
    gender: 'male',
    definiteArticle: 'lastExceptFirst'
  },
  focusedDonation: {
    singular: 'התרמה ממוקדת',
    plural: 'התרמות ממוקדות',
    gender: 'female',
    definiteArticle: 'all'
  },
  choiceDonation: {
    singular: 'התרמה (כללי)',
    plural: 'התרמות (כללי)',
    gender: 'female',
    definiteArticle: 'firstExceptLast'
  },
  ticketSales: {
    singular: 'מכירת כרטיסים',
    plural: 'מכירות כרטיסים',
    gender: 'female',
    definiteArticle: 'lastExceptFirst'
  },
  freeEventRegistration: {
    singular: 'הרשמה פתוחה לאירוע',
    plural: 'הרשמות פתוחות לאירוע',
    gender: 'female',
    definiteArticle: 'firstExceptLast'
  },
  choiceEvent: {
    singular: 'אירוע (כללי)',
    plural: 'אירועים (כללי)',
    gender: 'male',
    definiteArticle: 'firstExceptLast'
  },
  serviceRegistration: {
    singular: 'רישום לשירות',
    plural: 'רישום לשירות',
    gender: 'male',
    definiteArticle: 'firstExceptLast'
  },
  leads: { singular: 'פנייה', plural: 'פניות', gender: 'female', definiteArticle: 'all' },
  fixedFormLead: {
    singular: 'דף מידע או פנייה',
    plural: 'דפי מידע או פניות',
    gender: 'male',
    definiteArticle: [1, 3]
  }
};
